import { PreFooter } from '@sravni/react-pre-footer';
import type { FC } from 'react';
import { useMemo } from 'react';

import { useAppSelector } from 'shared/lib/redux';
import { AdaptiveCard } from 'shared/ui/AdaptiveCard';

import { metadataSelector } from 'entities/metadata';

import styles from './SeoPrefooter.module.scss';

export const SeoPrefooter: FC = () => {
  const metadata = useAppSelector(metadataSelector);

  const links = useMemo(() => {
    if (!metadata?.prefooter) {
      return [];
    }

    return metadata?.prefooter;
  }, [metadata?.prefooter]);

  if (!links?.length) {
    return null;
  }

  return (
    <AdaptiveCard color="light">
      <PreFooter
        columns={links.map((options) => ({
          ...options,
          links: options?.links.map(({ url, ...restOptions }) => ({
            url,
            ...restOptions,
          })),
        }))}
        className={styles.wrapper}
      />
    </AdaptiveCard>
  );
};
